<template>
  <kakao-logout></kakao-logout>
</template>

<script>
import KakaoLogout from '@/redcrm/components/customer/simple-signup/RcKakaoLogout';
export default {
    components:{
        KakaoLogout
    }
}
</script>

<style>

</style>